import { Box, Text } from "src/components/UI";
import { BulletNumberedImageCard } from "./Fragments";

type DirectDebitStepsContentProps = {
  title?: string;
  folder: string;
  length?: number;
};

const DirectDebitStepsContent = (props: DirectDebitStepsContentProps) => {
  const { title, folder, length } = props;

  if (!title) {
    return null;
  }

  return (
    <Box gap={["2px", "24px"]} flex={["unset", "6"]}>
      <Text
        padding={["16px"]}
        fontFamily="Roboto, sans-serif"
        fontWeight={["700"]}
        fontSize={["17px", "20px"]}
        lineHeight={["24px", "24px"]}
        letterSpacing={["0px", "-0.16px"]}
        color={["#404040"]}
      >
        {title}
      </Text>
      <Box
        display={["flex", "grid"]}
        gridTemplateColumns={["unset", "repeat(2, minmax(0, 1fr))"]}
        gridTemplateRows={["unset", "auto 1fr"]}
        gap={["16px", "0px 16px"]}
      >
        {Array.from(Array(length).keys()).map((_, index) => {
          const order = index + 1;
          const imageSrc = `/static/images/png/bayar-otomatis/${folder}/${order}.png`;

          return (
            <BulletNumberedImageCard
              key={index}
              imageAlt={title + "-" + order}
              imageSrc={imageSrc}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default DirectDebitStepsContent;
